import { render, staticRenderFns } from "./ListPerencanaanMpp.vue?vue&type=template&id=3ab2db06&scoped=true&"
import script from "./ListPerencanaanMpp.vue?vue&type=script&lang=ts&"
export * from "./ListPerencanaanMpp.vue?vue&type=script&lang=ts&"
import style0 from "./ListPerencanaanMpp.vue?vue&type=style&index=0&id=3ab2db06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2db06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDataTable,VIcon})
